import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import CallsLogin from '../views/CallsLogin.vue'
import Password from '../views/Password.vue'
import Summary from '../views/Summary.vue'
import Gaps from '../views/Gaps.vue'
import Schedule from '../views/Schedule.vue'
import Cases from '../views/Cases.vue'
import Calls from '../views/Calls.vue'
import Patients from '../views/Patients.vue'
import Notifications from '../views/Notifications.vue'
import NotifGapSMS from '../views/NotifGapSMS.vue'
import Providers from '../views/Providers.vue'
import MembersReport from '../views/MembersReport.vue'
import MemberCallReport from '../views/MemberCallReport.vue'
import AppointmentStatusReport from '../views/AppointmentStatusReport.vue'
import YearlyStatusReport from '../views/YearlyStatusReport.vue'
import StatusSummaryReport from '../views/StatusSummaryReport.vue'
import StatusSummaryReport2 from '../views/StatusSummaryReport2.vue'
import AppointmentTransportationCoordinationReport from '../views/AppointmentTransportationCoordinationReport.vue'
import CoordinationSummaryReport from '../views/CoordinationSummaryReport.vue'
import MessageSummaryReport from '../views/MessageSummaryReport.vue'
import Report from '../views/Report.vue'
import store from '../store'
import Calendars from '../views/Calendars.vue'
import Files from '../views/Files.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/password',
    name: 'password',
    component: Password
  },
  {
    path: '/password/:publicId',
    name: 'password_verify',
    component: Password,
    props: true
  },
  {
    path: '/pwd',
    name: 'pwd',
    component: Password
  },
  {
    path: '/pwd/:publicId',
    name: 'pwd_verify',
    component: Password,
    props: true
  },
  // GAPS
  {
    path: '/gaps/dashboard',
    name: 'gap-dashboard',
    component: Gaps,
    meta: {
      auth: true
    }
  },
  {
    path: '/gaps/notifications',
    name: 'gap-notifications',
    component: Notifications,
    meta: {
      auth: true
    }
  },
  {
    path: '/gaps/summary',
    name: 'gap-summary',
    component: Summary,
    meta: {
      auth: true
    }
  },
  //
  {
    path: '/schedule',
    name: 'schedule',
    component: Schedule,
    meta: {
      auth: true
    }
  },
  {
    path: '/cases',
    name: 'cases',
    component: Cases,
    meta: {
      auth: true
    }
  },
  {
    path: '/calls',
    name: 'calls',
    component: Calls,
    meta: {
      auth: true
    }
  },
  {
    path: '/calls/login',
    name: 'callslogin',
    component: CallsLogin,
  },
  {
    path: '/patients',
    name: 'patients',
    component: Patients,
    meta: {
      auth: true
    }
  },
  {
    path: '/n/:publicId',
    name: 'notifGapSMS',
    component: NotifGapSMS,
    props: true
  },
  {
    path: '/providers',
    name: 'providers',
    component: Providers,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/members',
    name: 'report-members',
    component: MembersReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/member/call',
    name: 'report-member-call',
    component: MemberCallReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/appointment/status',
    name: 'report-appointment-status',
    component: AppointmentStatusReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/yearly/status',
    name: 'report-yearly-status',
    component: YearlyStatusReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/status/summary',
    name: 'report-status-summary',
    component: StatusSummaryReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/status/summary2',
    name: 'report-status-summary-2',
    component: StatusSummaryReport2,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/appt/transportation',
    name: 'report-appt-transportation',
    component: AppointmentTransportationCoordinationReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/coordination/summary',
    name: 'report-coordination-summary',
    component: CoordinationSummaryReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report/message/summary',
    name: 'report-message-summary',
    component: MessageSummaryReport,
    meta: {
      auth: true
    }
  },
  {
    path: '/report',
    name: 'report',
    component: Report,
    meta: {
      auth: true
    }
  },
  {
    path: '/cases/report',
    name: 'cases-report',
    component: Report,
    meta: {
      auth: true
    }
  },
  {
    path: '/gaps/report',
    name: 'gaps-report',
    component: Report,
    meta: {
      auth: true
    }
  },
  {
    path: '/calendars',
    name: 'calendars',
    component: Calendars,
    meta: {
      auth: true
    }
  },
  {
    path: '/files',
    name: 'files',
    component: Files,
    meta: {
      auth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    const loggedIn = store.getters['auth/loggedIn'];
    if (loggedIn) {
      next()
      return
    }
    next({ name: 'login' })
  } else {
    next()
  }
})


export default router
